import { CardBody, Card } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';

const DayPlanIngredientReplacementList = ({
  renderOriginalProduct,
  hasReplacements,
  shouldRenderOryginalProduct,
  children,
}) => {
  const { t } = useTranslator();

  return (
    <Card>
      <CardBody>
        {shouldRenderOryginalProduct ? (
          <>
            <p className="semi-bold on-secondary-container">
              {t('mealDetails.changeIngredientBox.originalIngredient')}
            </p>
            <ul className="ingredients">{renderOriginalProduct()}</ul>
          </>
        ) : (
          ''
        )}

        {hasReplacements ? (
          <>
            <p className="semi-bold on-secondary-container">
              {t('mealDetails.changeIngredientBox.propositionsTitle')}
            </p>
            <ul className="ingredients">{children()}</ul>
          </>
        ) : (
          ''
        )}
      </CardBody>
    </Card>
  );
};

export default DayPlanIngredientReplacementList;
